/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Filter_GrowerInputs */

const vi_tea_purchase_filter_grower = /** @type {(inputs: Tea_Purchase_Filter_GrowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hộ trồng chè`)
};

/**

* @param {Tea_Purchase_Filter_GrowerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_filter_grower = /** @type {((inputs?: Tea_Purchase_Filter_GrowerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Filter_GrowerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_filter_grower(inputs)
});